var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SD",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 16.36,
    viewBox: "0 0 30 16.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25507",
    "data-name": "Path 25507",
    d: "M790.27.63a1.941,1.941,0,0,1,2.192,1.977V13.753a1.941,1.941,0,0,1-2.192,1.977H766.05a1.941,1.941,0,0,1-2.192-1.977V2.607A1.941,1.941,0,0,1,766.05.63Zm0-.63H766.05a2.6,2.6,0,0,0-2.89,2.607V13.753a2.6,2.6,0,0,0,2.89,2.607H790.27a2.6,2.6,0,0,0,2.89-2.607V2.607A2.6,2.6,0,0,0,790.27,0",
    transform: "translate(-763.16)",
    fill: "#220046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25527",
    "data-name": "Path 25527",
    d: "M-.5-5.306A3.11,3.11,0,0,0-3.13-6.56c-1.522,0-2.626.89-2.626,2.122,0,2.422,3.355,1.983,3.355,2.915,0,.322-.279.493-.815.493a1.848,1.848,0,0,1-1.565-.8L-6.035-.654A3.017,3.017,0,0,0-3.248.632C-1.63.632-.5-.322-.5-1.6-.5-4-3.859-3.591-3.859-4.481c0-.247.214-.418.654-.418a1.846,1.846,0,0,1,1.5.793ZM.406.471H2.9c2.24,0,3.891-1.447,3.891-3.419C6.794-4.942,5.144-6.4,2.9-6.4H.406ZM2.872-4.738A1.8,1.8,0,0,1,4.9-2.969,1.8,1.8,0,0,1,2.882-1.19H2.229V-4.738Z",
    transform: "translate(15.035 11.16)",
    fill: "#907fa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdIcon);
export default __webpack_public_path__ + "static/media/sd-icon.09db9868054448f504b1396ce543a30b.svg";
export { ForwardRef as ReactComponent };